export default __webpack_public_path__ + "static/Food2-655224d12ba2796fe921c4c1beb6dd34.jpg";